var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "container" } },
    [
      _c(
        "el-button",
        {
          class: { selecionado: _vm.btnCondicao },
          on: {
            click: function($event) {
              return _vm.handleClick("btn-0")
            }
          }
        },
        [_vm._v(_vm._s(_vm.botao0))]
      ),
      _c(
        "el-button",
        {
          class: { selecionado: !_vm.btnCondicao },
          on: {
            click: function($event) {
              return _vm.handleClick("btn-1")
            }
          }
        },
        [_vm._v(_vm._s(_vm.botao1))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34c5a7d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34c5a7d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios_ouvidoria/components/BotaoSelecionar.vue
// module id = null
// module chunks = 